<style lang="less" scoped>
.invoiceList {
    width: 100%;
    min-height: 100%;
    background-color: #f0f2f6;
    position: relative;
    padding-top: 100px;
    .header {
        width: 100%;
        height: 100px;
        background-color: #fff;
        // padding: 20px 40px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        .nut-searchbar {
            width: 88%;
        }
        // .nut-textinput {
        //     float: left;
        //     width: 80%;
        //     height: 34px;
        //     line-height: 34px;
        //     font-size: 13px;
        // }
        // span {
        //     float: right;
        //     margin-left: 20px;
        //     width: 34px;
        //     height: 34px;
        //     // background-color: #f2f2f2;
        //     display: flex;
        //     align-items: center;
        //     justify-content: center;
        // }
    }
    .list {
        width: 100%;
        // height: 104px;
        background-color: #fff;
        margin-top: 20px;
        padding: 30px 22px;
        box-sizing: border-box;
        text-align: left;
        .title {
            width: 100%;
            display: flex;
            justify-content:space-between;
            .left {
                display: flex;
                line-height: 48px;
                align-items: center;
                color: rgba(16, 16, 16, 1);
                font-size: 48px;
                img {
                    display: inline-block;
                    width: 48px;
                    height: 48px;
                    margin-right: 14px;
                }
            }
            .right {
                color: rgba(30, 173, 255, 1);
                font-size: 28px;
            }
            
        }
        .content {
            width: 100%;
            color: rgba(162, 157, 157, 1);
            font-size: 24px;
            margin-top: 20px;
            padding-left: 62px;
            box-sizing: border-box;
            .item {
                width: 100%;
                height: 40px;
                line-height: 40px;
            }
        }
        .footer {
            width: 100%;
            color: rgba(16, 16, 16, 1);
            font-size: 24px;
            text-align: right;
            .button {
                display: inline-block;
                width: 142px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                border-radius: 30px;
                text-align: center;
                border: 2px solid rgba(187, 187, 187, 1);
            }
        }
    }
    .invoiceImg {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0px;
        left: 0px;
        background-color: rgba(130, 130, 135, 0.3);
        display: flex;
	    justify-content: center;
        align-content: center;
        align-items: center;
        img {
            display: inline-block;
            width: 656px;
            height: 426px;
            // background-color: red;
        }
    }
}
</style>

<template>
  <div class="invoiceList">
      <div class="header">
          <!-- <nut-textinput
            v-model="value"
            placeholder="请输入个体户名称"
            :clearBtn="true"
            :disabled="false"
          />
          <span @click="sousuo">
            <nut-icon type="search"></nut-icon>
          </span> -->
          <nut-searchbar
            placeText="请输入个体户名称"
            @submit="sousuo"
          ></nut-searchbar>
      </div>
      <nut-infiniteloading 
        @loadmore="onInfinite" 
        :is-show-mod="true" 
        :has-more="isHasMore" 
        :is-loading="isLoading" 
        :threshold="200"
      >
      <div class="list" v-for="(item,key) in invoiceArr" :key="key">
          <div class="title">
              <div class="left">
                  <img src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_wxapplet_1585032971702.jpg" alt="">{{item.from_name}}
              </div>
              <div class="right">{{item.status_name}}</div>
          </div>
          <div class="content">
              <div class="item">商户名称：{{item.to_name}}</div>
              <div class="item">信用代码：{{item.to_credit_code}}</div>
              <div class="item">地址、电话：{{item.to_addr}} {{item.to_mobile}}</div>
              <div class="item">开户行及账号：{{item.to_bank}} {{item.to_account}}</div>
              <div class="item">发票金额（元）：{{item.invoice_amount}}</div>
              <div class="item">申请日期：{{item.invoice_time}}</div>
          </div>

          <div class="footer">
              <div class="button" @click="checkInvoice(item.invoice_img)">查看发票</div>
          </div>
      </div>
      </nut-infiniteloading>
      <!-- 查看发票 -->
      <div class="invoiceImg" v-if="invoiceType" @click.stop="guanbi">
          <img :src="invoiceImg" alt="">
      </div>
  </div>
</template>

<script>
import http from '../../api/index.js'
import config from "../../utils/config.js";

export default {
  data() {
    return {
        value:'',
        invoiceImg: '',
        invoiceType: false,
        invoiceArr: [
            {
                from_name: '哈哈哈哈哈',
                status_name: '222',
                to_name: '111',
                to_credit_code: '223',
                to_addr: '123',
                to_mobile: '233',
                to_bank: '124515',
                to_account: '56',
                invoice_amount: '12415',
                invoice_time: '2020.31045'
            }
        ],
        page: 1,
        count: 0,
        isHasMore: true,
        isLoading: false,
        isErr: false
    }
  },
  mounted() {
      this.invoiceArr = [];
      this.invoiceBycreditCodePost()
  },
  methods: {
    onInfinite () {
        this.isLoading = true;
        if (this.page <= this.count/10) {
            this.page = this.page + 1;
            this.invoiceBycreditCodePost()
        } else {
            this.isHasMore = false;
            this.isLoading = false;
        }
    },
    sousuo(e) {
        this.value = e;
        this.page = 1;
        this.invoiceArr = [];
        this.invoiceBycreditCodePost()
    },
    invoiceBycreditCodePost() {
        http.post(config.invoiceBycreditCode, {
            name: this.value,
            currentPage: this.page,
            pageSize: 10
        }).then(e => {
            console.log(e,'发票')
            if (e.code == 1) {
                this.count = e.data.count
                for (let i = 0; i < e.data.rows.length; i++) {
                   this.invoiceArr.push(e.data.rows[i]) 
                }
                // this.invoiceArr = e.data.rows
            }
            this.isLoading = false;
        });
    },
    checkInvoice(img) {
        console.log(img)
        if (!img || img == '') {
            return
        }
        this.invoiceType = true;
        this.invoiceImg = img
    },
    guanbi() {
        this.invoiceType = false;
    }
  },
  components: {

  }
}
</script>


// WEBPACK FOOTER //
// src/pages/invoiceList/index.vue